import { render } from "./TodoHeader.vue?vue&type=template&id=e16005ba&scoped=true"
import script from "./TodoHeader.vue?vue&type=script&lang=js"
export * from "./TodoHeader.vue?vue&type=script&lang=js"

import "./TodoHeader.vue?vue&type=style&index=0&id=e16005ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e16005ba"]])

export default __exports__